export function SquaresIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.425 0.125H0.125V6.425H6.425V0.125Z" />
      <path d="M6.425 9.57495H0.125V15.875H6.425V9.57495Z" />
      <path d="M9.57501 9.57495H15.875V15.875H9.57501V9.57495Z" />
      <path d="M15.875 0.125H9.57501V6.425H15.875V0.125Z" />
    </svg>
  );
}
